import * as React from "react";
import { observable, action } from "mobx";
import { inject, observer } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import ProfileStore from "../../../stores/profileStore";
import { hashHistory } from "react-router";
import Snackbar from 'material-ui/Snackbar';
import Fade from 'material-ui/transitions/Fade';
import Button from "material-ui/Button";

@observer
export default class SeekerSnackbar extends React.Component<{ store: SeekerStore }, {}> {

  constructor(props: any) {
    super(props);
  }

  @action handleClick = (): void => {
    this.props.store.viewState.setScrollToRecommendedOps(true);
    hashHistory.push(this.props.store.viewState.snackBarActionLink);   
    this.props.store.viewState.closeSnackbar();
  }

  render(): JSX.Element {
    const btnLink: any = {
      color: "#ffff00",
    }
    const actionMsg: string = this.props.store.viewState.snackBarActionText || "";
    return (
      <Snackbar
        open={this.props.store.viewState.showSnackbar}
        onClose={() => this.props.store.viewState.closeSnackbar()}
        autoHideDuration={5000}
        transition={Fade}
        message={<span id="message-id">{this.props.store.viewState.snackbarMessage}<br /></span>}
        action={this.props.store.viewState.snackBarActionLink !== null ? <Button color="secondary" style={btnLink} onClick={this.handleClick} size="large">{actionMsg}</Button> : null }
    />);
  }
}


// WEBPACK FOOTER //
// ./src/components/widgets/snackbar/index.tsx